import { render, staticRenderFns } from "./updates-filters.vue?vue&type=template&id=72ab02ac"
import script from "./updates-filters.vue?vue&type=script&lang=js"
export * from "./updates-filters.vue?vue&type=script&lang=js"
import style0 from "./updates-filters.vue?vue&type=style&index=0&id=72ab02ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VBtnToggle: require('/app/node_modules/vuetify/lib/components/VBtnToggle/VBtnToggle.js').default,VCheckbox: require('/app/node_modules/vuetify/lib/components/VCheckbox/VCheckbox.js').default,VListItemAction: require('/app/node_modules/vuetify/lib/components/VList/VListItemAction.js').default,VRow: require('/app/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VListItem: require('/app/node_modules/vuetify/lib/components/VList/VListItem.js').default,VSelect: require('/app/node_modules/vuetify/lib/components/VSelect/VSelect.js').default,VSpacer: require('/app/node_modules/vuetify/lib/components/VGrid/VSpacer.js').default,VDatePicker: require('/app/node_modules/vuetify/lib/components/VDatePicker/VDatePicker.js').default,VMenu: require('/app/node_modules/vuetify/lib/components/VMenu/VMenu.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VDatePicker,VListItem,VListItemAction,VListItemContent,VListItemTitle,VMenu,VRow,VSelect,VSpacer})
